function getYouTubeThumbnail(videoId) {
  if (!videoId) return "";
  return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
}

async function loadMediaRoundup() {
  try {
    const response = await fetch(window.mediaRoundupDataUrl);

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    const data = await response.json();

    renderMeta(data);
    //renderTrending(data.trending_games || []);
    renderVideoList("media-roundup-latest-list", data.latest_videos || [], 40);
    renderVideoList("media-roundup-reviews-list", (data.sections && data.sections.reviews) || [], 20);
    renderVideoList("media-roundup-how-to-play-list", (data.sections && data.sections.how_to_play) || [], 20);
    renderVideoList("media-roundup-playthroughs-list", (data.sections && data.sections.playthroughs) || [], 20);
    renderVideoList("media-roundup-crowdfunding-list", (data.sections && data.sections.crowdfunding) || [], 20);
    renderVideoList("media-roundup-previews-list", (data.sections && data.sections.previews) || [], 20);
    renderVideoList("media-roundup-lists-list", (data.sections && data.sections.lists) || [], 20);
    renderStructuredData(data);
  } catch (err) {
    console.error("Media Roundup failed:", err);

    renderError("media-roundup-meta", "Unable to load roundup stats.");
    //renderError("media-roundup-trending-grid", "Unable to load trending games.");
    renderError("media-roundup-latest-list", "Unable to load latest videos.");
    renderError("media-roundup-reviews-list", "Unable to load reviews.");
    renderError("media-roundup-how-to-play-list", "Unable to load how-to-play videos.");
    renderError("media-roundup-playthroughs-list", "Unable to load playthroughs.");
    renderError("media-roundup-crowdfunding-list", "Unable to load crowdfunding.");
    renderError("media-roundup-previews-list", "Unable to load previews.");
    renderError("media-roundup-lists-list", "Unable to load lists and roundups.");
  }
}

function renderMeta(data) {
  const el = document.getElementById("media-roundup-meta");
  if (!el) return;

  el.className = "media-roundup-meta";
  el.innerHTML = `
    <p>
      Updated ${escapeHtml(formatDateTime(data.generated_at || ""))}
      • ${Number((data.stats && data.stats.video_count) || 0)} videos
      • ${Number((data.stats && data.stats.game_count) || 0)} games
      • ${Number((data.stats && data.stats.channel_count) || 0)} channels tracked
    </p>
  `;
}

function getTrendingSummary(item) {
  const title = item.title || "This game";
  const parts = [];

  if (item.review_count) {
    parts.push(item.review_count === 1 ? "a review" : "reviews");
  }

  if (item.playthrough_count) {
    parts.push(item.playthrough_count === 1 ? "a playthrough" : "playthroughs");
  }

  if (item.how_to_play_count) {
    parts.push(item.how_to_play_count === 1 ? "a how-to-play video" : "how-to-play videos");
  }

  if (item.list_count) {
    parts.push(item.list_count === 1 ? "a list feature" : "list features");
  }

  if (!parts.length) {
    return `${title} has recently been featured across popular board game YouTube coverage.`;
  }

  if (parts.length === 1) {
    return `${title} has recently been featured in ${parts[0]} from popular board game channels.`;
  }

  if (parts.length === 2) {
    return `${title} has recently been featured in ${parts[0]} and ${parts[1]} from popular board game channels.`;
  }

  const last = parts.pop();
  return `${title} has recently been featured in ${parts.join(", ")}, and ${last} from popular board game channels.`;
}

function getCoverageAnchorId(title) {
  const clean = String(title || "")
    .toLowerCase()
    .trim()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

  return clean ? `game-${clean}` : "";
}

function renderTrending(items) {
  const container = document.getElementById("media-roundup-trending-grid");
  if (!container) return;

  if (!items.length) {
    container.className = "media-roundup-empty";
    container.innerHTML = "<p>No trending games available right now.</p>";
    return;
  }

  container.className = "media-roundup-grid media-roundup-grid--featured";

  container.innerHTML = items.slice(0, 12).map(function (item) {
    const reviewText = item.review_count ? `${item.review_count} review${item.review_count === 1 ? "" : "s"}` : "";
    const playthroughText = item.playthrough_count ? `${item.playthrough_count} playthrough${item.playthrough_count === 1 ? "" : "s"}` : "";
    const teachText = item.how_to_play_count ? `${item.how_to_play_count} how to play` : "";
    const listText = item.list_count ? `${item.list_count} list mention${item.list_count === 1 ? "" : "s"}` : "";

    const badges = [reviewText, playthroughText, teachText, listText].filter(Boolean);
    const videos = (item.videos || []).slice(0, 4);
    const summary = getTrendingSummary(item);
    const anchorId = getCoverageAnchorId(item.title);

    const titleHtml = item.store_url
      ? `<a href="${escapeAttr(item.store_url)}" class="media-game-card__title-link">${escapeHtml(item.title || "")}</a>`
      : escapeHtml(item.title || "");

    return `
      <article class="media-game-card media-game-card--featured" ${anchorId ? `id="${escapeAttr(anchorId)}"` : ""}>
        <div class="media-game-card__top">
          <div class="media-game-card__eyebrow">Trending Game</div>
          <h3 class="media-game-card__title">${titleHtml}</h3>
          <p class="media-game-card__stats">
            <strong>${Number(item.video_count || 0)}</strong> videos ·
            <strong>${Number(item.channel_count || 0)}</strong> channels
          </p>
        </div>

        ${
          badges.length
            ? `
              <div class="media-game-card__badges">
                ${badges.map(function (b) {
                  return `<span class="media-game-card__badge">${escapeHtml(b)}</span>`;
                }).join("")}
              </div>
            `
            : ""
        }

        <p class="media-game-card__summary">
          ${escapeHtml(summary)}
        </p>

        ${
          videos.length
            ? `
              <div class="media-game-card__thumb-grid">
                ${videos.map(function (video) {
                  const thumb = getYouTubeThumbnail(video.video_id);

                  return `
                    <a
                      class="media-game-card__thumb"
                      href="${escapeAttr(video.youtube_link || "#")}"
                      target="_blank"
                      rel="noopener"
                      aria-label="${escapeHtml(video.video_title || "Open video")}"
                    >
                      ${
                        thumb
                          ? `
                            <span class="media-game-card__thumb-inner">
                              <img
                                src="${escapeAttr(thumb)}"
                                alt="${escapeHtml(video.video_title || "YouTube video thumbnail")}"
                                loading="lazy"
                              >
                              <span class="media-game-card__play" aria-hidden="true"></span>
                            </span>
                          `
                          : `<span class="media-game-card__thumb-placeholder">No image</span>`
                      }
                    </a>
                  `;
                }).join("")}
              </div>
            `
            : ""
        }

        <div class="media-game-card__coverage-label">Recent coverage</div>

        <ul class="media-game-card__videos">
          ${(item.videos || []).slice(0, 4).map(function (video) {
            return `
              <li>
                <a href="${escapeAttr(video.youtube_link || "#")}" target="_blank" rel="noopener">
                  ${escapeHtml(video.video_title || "")}
                </a>
                <span>
                  ${escapeHtml(video.channel || "")}
                  ${video.type ? ` · ${escapeHtml(video.type)}` : ""}
                  ${video.published ? ` · ${escapeHtml(formatDate(video.published))}` : ""}
                </span>
              </li>
            `;
          }).join("")}
        </ul>

<div class="media-game-card__actions">
  ${
    item.store_url
      ? `<a class="button ${item.in_stock ? 'button--primary' : 'button--view'}" href="${escapeAttr(item.store_url)}">${item.in_stock ? 'Buy Game' : 'View Game'}</a>`
      : ""
  }
  <a class="button button--secondary" href="#media-roundup-latest-heading">See All Coverage</a>
</div>
      </article>
    `;
  }).join("");
}

function renderVideoList(id, videos, maxItems) {
  const container = document.getElementById(id);
  if (!container) return;

  if (!videos.length) {
    container.className = "media-roundup-empty";
    container.innerHTML = "<p>No videos available right now.</p>";
    return;
  }

  container.className = "media-roundup-list";

  const limit = Number(maxItems) || 20;

  container.innerHTML = videos.slice(0, limit).map(function (v) {   
    const thumb = getYouTubeThumbnail(v.video_id);
    const typeLabel = v.type || "Video";
    const gameChip = v.game_title
      ? (
          v.store_url
            ? `<a class="media-video-game-chip media-video-game-chip--link" href="${escapeAttr(v.store_url)}">${escapeHtml(v.game_title)}</a>`
            : `<div class="media-video-game-chip">${escapeHtml(v.game_title)}</div>`
        )
      : "";

    return `
      <article class="media-video-card">
        <a
          class="media-video-card__thumb"
          href="${escapeAttr(v.youtube_link || "#")}"
          target="_blank"
          rel="noopener"
        >
          ${
            thumb
              ? `
                <div class="media-video-card__thumb-inner">
                  <img
                    src="${escapeAttr(thumb)}"
                    alt="${escapeHtml(v.video_title || "YouTube video thumbnail")}"
                    loading="lazy"
                  >
                  <span class="media-video-card__play" aria-hidden="true"></span>
                </div>
              `
              : `<div class="media-video-card__thumb-placeholder">No image</div>`
          }
        </a>

        <div class="media-video-card__body">
          <div class="media-video-card__eyebrow">${escapeHtml(typeLabel)}</div>

          <h3 class="media-video-card__title">
            <a
              href="${escapeAttr(v.youtube_link || "#")}"
              target="_blank"
              rel="noopener"
            >
              ${escapeHtml(v.video_title || "")}
            </a>
          </h3>

          <div class="media-video-card__meta">
            <span>${escapeHtml(v.channel || "")}</span>
            ${v.published ? `<span>${escapeHtml(formatDate(v.published))}</span>` : ""}
          </div>

          ${gameChip}
        </div>

<div class="media-video-card__actions">
  <a
    class="button button--secondary"
    href="${escapeAttr(v.youtube_link || "#")}"
    target="_blank"
    rel="noopener"
  >
    Watch Video
  </a>
  ${
    v.store_url
      ? `<a class="button ${v.in_stock ? 'button--primary' : 'button--view'}" href="${escapeAttr(v.store_url)}">${v.in_stock ? 'Buy Game' : 'View Game'}</a>`
      : ""
  }
</div>
      </article>
    `;
  }).join("");
}

function renderStructuredData(data) {
  const existing = document.getElementById("media-roundup-schema");
  if (existing) existing.remove();

  const canonicalUrl =
    window.location.origin + window.location.pathname;

  const latestVideos = (data.latest_videos || []).slice(0, 20);
  const trendingGames = (data.trending_games || []).slice(0, 12);

  const itemListElements = latestVideos.map(function (video, index) {
    const obj = {
      "@type": "VideoObject",
      name: video.video_title || "Board game video",
      url: video.youtube_link || undefined,
      thumbnailUrl: video.video_id ? getYouTubeThumbnail(video.video_id) : undefined,
      uploadDate: toIsoDate(video.published),
      publisher: video.channel
        ? {
            "@type": "Organization",
            name: video.channel
          }
        : undefined,
      about: video.game_title
        ? {
            "@type": "Thing",
            name: video.game_title,
            url: video.store_url || undefined
          }
        : undefined,
      position: index + 1
    };

    return stripUndefined(obj);
  });

  const aboutGames = trendingGames.map(function (game) {
    return stripUndefined({
      "@type": "Thing",
      name: game.title || undefined,
      url: game.store_url || undefined
    });
  });

  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      stripUndefined({
        "@type": "CollectionPage",
        "@id": canonicalUrl + "#page",
        url: canonicalUrl,
        name: "Board Game Media Roundup | Cloak & Gamer",
        description: "Latest board game reviews, playthroughs, how-to-play videos, and roundup coverage from across tabletop gaming YouTube.",
        isPartOf: {
          "@type": "WebSite",
          name: "Cloak & Gamer",
          url: window.location.origin
        },
        about: aboutGames.length ? aboutGames : undefined
      }),
      stripUndefined({
        "@type": "ItemList",
        "@id": canonicalUrl + "#itemlist",
        name: "Latest Board Game Media Coverage",
        itemListElement: itemListElements
      })
    ]
  };

  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.id = "media-roundup-schema";
  script.text = JSON.stringify(schema);

  document.head.appendChild(script);
}

function toIsoDate(value) {
  if (!value) return undefined;
  const d = new Date(value);
  if (isNaN(d.getTime())) return undefined;
  return d.toISOString();
}

function stripUndefined(obj) {
  if (Array.isArray(obj)) {
    return obj
      .map(stripUndefined)
      .filter(function (value) {
        return value !== undefined && value !== null;
      });
  }

  if (obj && typeof obj === "object") {
    const clean = {};
    Object.keys(obj).forEach(function (key) {
      const value = stripUndefined(obj[key]);
      if (value !== undefined && value !== null && value !== "") {
        clean[key] = value;
      }
    });
    return clean;
  }

  return obj;
}

function renderError(id, message) {
  const container = document.getElementById(id);
  if (!container) return;

  container.className = "media-roundup-error";
  container.innerHTML = `<p>${escapeHtml(message)}</p>`;
}

function formatDate(value) {
  if (!value) return "";

  // If it's a date-only string like 2026-03-16, avoid UTC shift
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const parts = value.split("-");
    const d = new Date(parts[0], parts[1] - 1, parts[2]);
    return d.toLocaleDateString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric"
    });
  }

  const d = new Date(value);
  if (isNaN(d.getTime())) return String(value);

  return d.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric"
  });
}

function escapeHtml(str) {
  return String(str || "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;");
}

function escapeAttr(str) {
  return escapeHtml(str);
}

function initRoundupTabs() {
  const links = Array.from(document.querySelectorAll(".media-roundup-tabs__link"));
  if (!links.length) return;

  const sectionMap = links
    .map(function (link) {
      const id = link.getAttribute("href");
      if (!id || !id.startsWith("#")) return null;
      const section = document.querySelector(id);
      if (!section) return null;
      return { link: link, section: section };
    })
    .filter(Boolean);

  function setActive(linkToActivate) {
    links.forEach(function (link) {
      link.classList.toggle("is-active", link === linkToActivate);
    });
  }

  links.forEach(function (link) {
    link.addEventListener("click", function () {
      setActive(link);
    });
  });

  if ("IntersectionObserver" in window && sectionMap.length) {
    const observer = new IntersectionObserver(
      function (entries) {
        const visible = entries
          .filter(function (entry) {
            return entry.isIntersecting;
          })
          .sort(function (a, b) {
            return b.intersectionRatio - a.intersectionRatio;
          });

        if (!visible.length) return;

        const active = sectionMap.find(function (item) {
          return item.section === visible[0].target;
        });

        if (active) setActive(active.link);
      },
      {
        rootMargin: "-25% 0px -55% 0px",
        threshold: [0.1, 0.25, 0.5]
      }
    );

    sectionMap.forEach(function (item) {
      observer.observe(item.section);
    });
  } else if (links[0]) {
    setActive(links[0]);
  }
}

function formatDateTime(value) {
  if (!value) return "";

  const d = new Date(value);
  if (isNaN(d.getTime())) return String(value);

  return d.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit"
  });
}

document.addEventListener("DOMContentLoaded", function () {
  loadMediaRoundup();
  initRoundupTabs();
});

